import { useCallback } from 'react';
import { useGetPromoChannelStatsQuery } from '../../../../redux/api/fymAPI';
import { SocialPlatform } from '../types';

interface UseChannelStatsProps {
  accountId: number;
  platform: SocialPlatform;
  /** The period in days. The server limits it to the history window of the plan. */
  days: number;
  /** True for a channel with no daily read: the request does not go out. */
  skip?: boolean;
}

/** The daily numbers of one channel: `GET promo/channels/:platform/stats?days`. Oldest day first. */
export function useChannelStats({ accountId, platform, days, skip = false }: UseChannelStatsProps) {
  const { currentData, isLoading, error, refetch } = useGetPromoChannelStatsQuery(
    { accountId, platform, days },
    { skip }
  );

  const retry = useCallback(() => {
    refetch().catch(console.error);
  }, [refetch]);

  return { days: currentData?.days, isLoading, error, retry };
}
